/**
 * Loads the Universign embed.js script dynamically.
 * No-op if already loaded.
 */
export function loadUniversignScript(endpoint) {
  if (window.universignSigInit) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${endpoint}/sig/embed.js`;
    script.onload = resolve;
    script.onerror = () => reject(
      new Error('Failed to load Universign script')
    );
    document.head.appendChild(script);
  });
}

/**
 * Loads the Universign script and initializes the signature
 * iframe in the given container.
 */
export function initSignature(containerId, eSignId, endpoint) {
  if (!eSignId) return Promise.resolve();

  return loadUniversignScript(endpoint).then(() => {
    if (window.universignSigInit) {
      window.universignSigInit(
        containerId,
        eSignId,
        {redirectionMode: 'IN'},
        endpoint
      );
    }
  });
}

/**
 * Listens for Universign postMessage completion events.
 * Returns a cleanup function to remove the listener.
 */
export function onUniversignComplete(callback) {
  const handler = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type !== 'universign:complete') return;

    const success =
      event.data.status === 'success' ||
      event.data.status === 'already_signed';

    callback({success});
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
}
